 
import React, { useEffect, useRef } from "react";
import {useNavigate} from "react-router-dom";
import './not-found.css';
const waveStyle = (i: number): React.CSSProperties =>
  ({ '--i': i } as React.CSSProperties);



function NotFound() {

  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const animationRef = useRef<number>();

  const navigate = useNavigate();
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const c = canvas.getContext("2d");
    if (!c) return;

    let numStars = 1900;
    let focalLength = canvas.width * 2;
    let centerX = 0;
    let centerY = 0;

    let stars: {
      x: number;
      y: number;
      z: number;
      o: string;
    }[] = [];

    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      centerX = canvas.width / 2;
      centerY = canvas.height / 2;
      focalLength = canvas.width * 2;
      initStars();
    };

    const initStars = () => {
      stars = [];
      for (let i = 0; i < numStars; i++) {
        stars.push({
          x: Math.random() * canvas.width,
          y: Math.random() * canvas.height,
          z: Math.random() * canvas.width,
          o: `0.${Math.floor(Math.random() * 99) + 1}`,
        });
      }
    };

    const moveStars = () => {
      stars.forEach((star) => {
        star.z -= 1;
        if (star.z <= 0) star.z = canvas.width;
      });
    };

    const drawStars = () => {
      c.fillStyle = "rgba(255,255,255,1)";
      c.fillRect(0, 0, canvas.width, canvas.height);

      stars.forEach((star) => {
        const x =
          (star.x - centerX) * (focalLength / star.z) + centerX;
        const y =
          (star.y - centerY) * (focalLength / star.z) + centerY;
        const r = 1 * (focalLength / star.z);

        c.fillStyle = `rgba(255,179,16,${star.o})`;
        c.fillRect(x, y, r, r);
      });
    };

   
    const animate = () => {
      moveStars();
      drawStars();
      animationRef.current = requestAnimationFrame(animate);
    };

    resizeCanvas();
    animate();

    window.addEventListener("resize", resizeCanvas);

    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
      window.removeEventListener("resize", resizeCanvas);
    };
  }, []);

  const goBack =()=>{
    navigate(-1)
  }


  return ( <div>
 

 
<section className="errorMain">
    <div id="w" style={{ overflow: "hidden" }}>
      <canvas id="space" ref={canvasRef} />
    </div>

    <img className="shape_1" src="../images/main-about-decor.png" alt="shape"/>
    <img className="shape_2" src="../images/main-about-decor.png" alt="shape" />
    <img className="circleBig" src="../images/circlebig.png" alt="circle"/> 


    <div className="errorInner">
      <h1>4<span> 0</span>4</h1>
      <h2 className="waviy">
        <span style={waveStyle(1)}>P</span>
        <span style={waveStyle(2)}>a</span>
        <span style={waveStyle(3)}>g</span>
        <span style={waveStyle(4)}>e</span>
        <span className="space">
          <span className="color-black" style={waveStyle(5)}>N</span>
          <span className="color-black" style={waveStyle(6)}>o</span>
          <span className="color-black" style={waveStyle(7)}>t</span>
        </span>
        <span style={waveStyle(8)}>F</span>
        <span style={waveStyle(9)}>o</span>
        <span style={waveStyle(10)}>u</span>
        <span style={waveStyle(11)}>n</span>
        <span style={waveStyle(12)}>d</span>
      </h2>
        <p>The page you're looking for doesn't exist or has been moved.</p>    
      <div className="errorBtn" onClick={goBack}>
        {/* <a href="" className="btn btnYellow">Back</a> */}
          <button className="btn btnYellow">Back</button>
      </div>
    </div>
</section>  


    </div>)
}

export default NotFound;
